import { z } from 'zod';
export const Event = z.object({
    id: z.string().uuid(),
    name: z.string().min(1),
    date: z.string().date(),
    emailSubject: z.string().nullable().optional(),
    createdAt: z.string().datetime(),
    updatedAt: z.string().datetime(),
});
export const CreateEventInput = z.object({
    name: z.string().min(1),
    date: z.string().date(),
});
export const UpdateEventInput = z.object({
    emailSubject: z.string().min(1).max(200).nullable().optional(),
});
/** `GET /api/events` responde un arreglo directo en `data` (sin paginacion). */
export const EventsListResponse = z.array(Event);
//# sourceMappingURL=event.js.map